/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Pc_Online_Cmp_Version_WebInputs */

const en_pc_online_cmp_version_web = /** @type {(inputs: Pc_Online_Cmp_Version_WebInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.version}, updated by us`)
};

const zh_pc_online_cmp_version_web = /** @type {(inputs: Pc_Online_Cmp_Version_WebInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.version}，由本站更新`)
};

/**
* | output |
* | --- |
* | "{version}, updated by us" |
*
* @param {Pc_Online_Cmp_Version_WebInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_cmp_version_web = /** @type {((inputs: Pc_Online_Cmp_Version_WebInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Cmp_Version_WebInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_cmp_version_web(inputs)
	return zh_pc_online_cmp_version_web(inputs)
});
export { pc_online_cmp_version_web as "pc.online.cmp.version.web" }